// Multivariate Dependencies
import React from 'react';
// Components
import { Avatar } from '../../Avatar/components/Avatar';
// Types
import { AvatarSize } from '../../Avatar/types/AvatarProps';
/**
 * @deprecated Do not use legacy components anymore.
 */
export var AvatarIcon = function (_a) {
    var alt = _a.alt, icon = _a.icon;
    var name = icon.name, initials = icon.initials, image = icon.image, color = icon.color, size = icon.size;
    return (React.createElement(Avatar, { size: size || AvatarSize.Small, name: name || alt, initials: initials, image: image, color: color }));
};
AvatarIcon.defaultProps = {
    alt: '',
};
//# sourceMappingURL=AvatarIcon.js.map